import React, { createContext, useState, useContext, ReactNode } from 'react';
// Định nghĩa kiểu dữ liệu cho context
interface AppContextType {
  selectedRole: string;
  setSelectedRole: (role: string) => void;
  // Bạn có thể thêm các state và function khác ở đây
}

// Tạo context với giá trị mặc định
const AppContext = createContext<AppContextType | undefined>(undefined);

// Hook để sử dụng context
// eslint-disable-next-line react-refresh/only-export-components
export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};

// Provider component
interface AppProviderProps {
  children: ReactNode;
}

export const AppProvider: React.FC<AppProviderProps> = ({ children }) => {
  const [selectedRole, setSelectedRole] = useState<string>('');

  const value = {
    selectedRole,
    setSelectedRole,
    // Thêm các state và function khác ở đây
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
